import { Box, ButtonBase, styled } from '@mui/material';

export const BoxContainer = styled(Box)(({ theme }) => ({
  [theme.breakpoints.up('xl')]: {
    padding: '40px 60px',
  },
}));

export const RadioButtonContainer = styled(Box)(() => ({
  width: '100%',
  display: 'flex',
}));

export const TopButton = styled(ButtonBase)(({ theme }) => ({
  flex: 1,
  height: 40,
  color: theme.palette.secondary.main,
  font: '400 16px Montserrat',
  border: `1px solid ${theme.palette.secondary.main}`,
  borderRadius: '4px 0px 0px 4px',
  '& + button': {
    borderRadius: '0px 4px 4px 0px',
  },
  '&.selected': {
    font: '600 16px Montserrat',
    background: theme.palette.secondary.main,
    color: '#FFFFFE',
  },
}));
